import React, { useState } from 'react';
import Main from '../components/Main';
import ScrollAnimation from 'react-animate-on-scroll';
import Typography from '../components/Typography';
import { BookOpen, Shield, FileText } from 'lucide-react';
import ChangeLog from '../components/ChangeLog/ChangeLog';
import GettingStarted from '../components/help/GettingStarted';
import PrivacyPolicy from '../components/help/PrivacyPolicy';
import InfoBox from '../components/help/InfoBox';

type InfoBoxType = 'getting-started' | 'privacy' | 'changelog';

const infoBoxes = [
  {
    id: 'getting-started' as InfoBoxType,
    title: 'Getting Started',
    icon: BookOpen,
    color: 'blue',
  },
  {
    id: 'privacy' as InfoBoxType,
    title: 'Privacy and Security',
    icon: Shield,
    color: 'green',
  },
  {
    id: 'changelog' as InfoBoxType,
    title: 'Changelog',
    icon: FileText,
    color: 'purple',
  },
];

const Home: React.FC = () => {
  const [activeBox, setActiveBox] = useState<InfoBoxType>('getting-started');

  const renderContent = () => {
    switch (activeBox) {
      case 'getting-started':
        return <GettingStarted />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'changelog':
        return <ChangeLog />;
      default:
        return null;
    }
  };

  return (
    <Main className="main-default">
      <div className="main-default container lg:py-3xl lg:pb-7xl xs-md:pb-6xl">
        <ScrollAnimation animateIn="fadeInUp" animateOnce>
          <div className="flex flex-col items-center gap-2xl pb-3xl xs:gap-xl xs:px-xl xs:text-center">
            <Typography tag="h1" variant="display-md">
              Help Center
            </Typography>
            <Typography tag="h2" variant="text-lg">
              Find the information you need
            </Typography>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInUp" animateOnce>
          <div className="mx-auto min-h-screen space-y-6 p-6">
            <div className="mb-8 grid grid-cols-3 gap-4 pb-10 xs:grid-cols-1">
              {infoBoxes.map(box => (
                <InfoBox
                  key={box.id}
                  title={box.title}
                  icon={box.icon}
                  isActive={activeBox === box.id}
                  onClick={() => setActiveBox(box.id)}
                  activeColor={box.color}
                />
              ))}
            </div>

            <div className="mt-8">{renderContent()}</div>
          </div>
        </ScrollAnimation>
      </div>
    </Main>
  );
};

export default Home;
